import { CommonDialog } from "@/components/common/CommonDialog";
import { FormButtonGroup } from "@/components/form";
import {
  DialogTitle,
  Typography,
  Stack,
} from "@mui/material";
import { useState } from "react";

interface CancelIntegrationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  agentName: string;
}

export function CancelIntegrationModal({
  open,
  onClose,
  onConfirm,
  agentName,
}: CancelIntegrationModalProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CommonDialog
        isOpen={open}
        handleClose={onClose}
      >
        <DialogTitle align="center">Confirmar desativação da extensão {agentName}</DialogTitle>
        <Typography variant="subtitle2" fontWeight="500" align="center" mb={2}>
          Após a confirmação, a extensão {agentName} será desabilitada e os recursos adicionais não estarão mais disponíveis.
        </Typography>
        <Stack direction="row" justifyContent="space-between" width="100%">
          <FormButtonGroup 
            onGoBackButtonClick={onClose}
            onNextButtonClick={handleConfirm} 
            nextButtonText="Confirmar"
            goBackButtonText="Fechar"
            loading={isLoading}
          />
        </Stack>
      </CommonDialog>
  );
} 